import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { INotification } from "../../../interfaces";
import NotificationV2Service from "../../services/notification-v2.service";

@Component({
    selector: "notification-row",
    imports: [MatIconModule, MatButtonModule, MatTooltipModule],
    templateUrl: "./notification-row.component.html",
    styleUrl: "./notification-row.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationRowComponent {
    @Input({ required: true }) notification: INotification;
    @Output() dismiss = new EventEmitter<void>();
    @Output() action = new EventEmitter<void>();

    get isAlert(): boolean {
        return this.notification.Type === "alert";
    }

    get isWarning(): boolean {
        return this.notification.Type === "warning";
    }

    get isFraud(): boolean {
        return this.notification.Metadata?.[NotificationV2Service.FRAUD_METADATA_KEY] === "true";
    }

    get actionLabel(): string | null {
        if (this.notification.Action?.Route) {
            return this.notification.Action.Label || "View details";
        }
        return null;
    }

    get icon(): string {
        const key = this.notification.Icon ? this.notification.Icon.toLowerCase() : "";
        if (this.isFraud || key === "shield" || key === "shield-x") return "gpp_bad";
        if (key === "check" || key === "check-circle") return "check_circle";
        if (key === "warning" || key === "alert-triangle") return "warning";
        if (key === "info") return "info";
        if (this.isAlert) return "gpp_bad";
        return "info";
    }

    formatExpiry(expireDateTime: string): string {
        const diffMs = new Date(expireDateTime).getTime() - Date.now();
        if (diffMs <= 0) return "Expired";
        const mins = Math.round(diffMs / 60000);
        if (mins < 60) return `Expires in ${mins}m`;
        const hours = Math.round(mins / 60);
        if (hours < 24) return `Expires in ${hours}h`;
        const days = Math.round(hours / 24);
        return `Expires in ${days}d`;
    }

    onRowClick(): void {
        if (this.actionLabel) {
            this.action.emit();
        }
    }

    onDismissClick(event: MouseEvent): void {
        event.stopPropagation();
        this.dismiss.emit();
    }
}
